import { matchPath, NavLink } from 'react-router-dom';
import { Navbar } from 'yoso';
import { T } from '~/components/I18n';

export type GlobalNavbarProps = { className?: string };

const CITIZEN_STORE_URL = import.meta.env.VITE_CITIZEN_STORE_URL;
export const GlobalNavbar = ({ className }: GlobalNavbarProps) => (
  <Navbar className={className}>
    <li>
      <a
        href={`${CITIZEN_STORE_URL}/1st_sale`}
        data-event="click"
        data-event-target="gnb_1st_sale_btn">
        <T name="citizen_menu_b2c" />
      </a>
    </li>
    <li>
      <a
        href={`${CITIZEN_STORE_URL}/marketplace`}
        data-event="click"
        data-event-target="gnb_marketplace_btn">
        <T name="citizen_menu_citizen_marketplace" />
      </a>
    </li>
    <li>
      <NavLink
        to="/membership/item/citizen/levelup"
        data-event="click"
        data-event-target="gnb_levelup_btn">
        <T name="citizen_menu_levelup" />
      </NavLink>
    </li>
    <li>
      <NavLink
        to="/membership/item/friend/levelup"
        data-event="click"
        data-event-target="gnb_evolve_btn">
        <T name="citizen_menu_evolve" />
      </NavLink>
    </li>
    <li>
      <NavLink
        to="/challenge/leaderboard"
        data-event="click"
        data-event-target="gnb_challenge_btn"
        isActive={(_, location) => !!matchPath(location.pathname, { path: '/challenge' })}>
        <T name="citizen_menu_challenge" />
      </NavLink>
    </li>
    <li>
      <NavLink to="/adventure" data-event="click" data-event-target="gnb_adventure_btn">
        <T name="citizen_menu_adventure" />
      </NavLink>
    </li>
  </Navbar>
);
